import React from "react";
import { useParams } from "react-router-dom";
import PasswordRecovery from "../templates/PasswordRecovery";
import UseLandingLoader from "../../hooks/useLandingLoader";
import TransitionWrapper from "../atoms/TransitionWrapper";

const ForgetPasswordPage = () => {
  UseLandingLoader();
  const params = useParams();
  
  return (
    <TransitionWrapper>
      <PasswordRecovery portal={params.userType} />
    </TransitionWrapper>
  );
};

export default ForgetPasswordPage;
